export default __webpack_public_path__ + "static/media/codegen-prompt.e5abc8e2.md";